import React, { useCallback } from 'react'

import AddressPickerSearchCard from 'APP/Converse/AddressPickerSearchCard'
import { transformAnswer } from 'APP/Lib/PlacesHelper'
import styled from 'styled-components/native'
import type { IntakeAddressSearchProps } from './types'
import { PlaceDetails } from '@dialogue/coredata'

const StyledAddressPickerSearchCard = styled(AddressPickerSearchCard)`
  min-height: 200px;
  overflow: scroll;
`

const IntakeAddressSearch: React.FC<IntakeAddressSearchProps> = ({
  sendAnswer,
  placeholder_text,
  place_type = 'address',
  style,
}) => {
  const onSubmitCallback = useCallback(
    (answer: PlaceDetails | undefined) => {
      sendAnswer(transformAnswer(answer))
    },
    [sendAnswer]
  )

  return (
    <StyledAddressPickerSearchCard
      style={style}
      placeholder={placeholder_text}
      onSubmitCallback={onSubmitCallback}
      type={place_type}
    />
  )
}

export default IntakeAddressSearch
